export default __webpack_public_path__ + "static/media/alphafitness-details.bcf4c217.PNG";